var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pagein"},[_c('div',[_c('img',{attrs:{"src":require("../assets/" + _vm.$route.query.id + ".jpg")}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }